import styled from 'styled-components'

import { colors, spaces } from '@/config/global-parameters'
import { normalNumberFormatter, percentFormatter } from '@/helpers/formatters'
import { showInDesktop, showInMobile } from '@/styles/mediaQueries'

export interface IPartido {
  sigla: string
  ratio: number
}
export interface IPacto {
  nombre: string
  shortName?: string
  color: string
  ratioLista: number
  order: number
  votosLista: number
  partidos: IPartido[]
}

const Pacto = ({ color, nombre, partidos, ratioLista, shortName, votosLista }: IPacto) => (
  <>
    <WrapperNameNumber color={color}>
      <Porcentaje>{percentFormatter.format(Number(ratioLista) || 0)}</Porcentaje>
      <Name>{nombre}</Name>
      <ShortName>{shortName}</ShortName>
    </WrapperNameNumber>
    <Line />
    <Votos>{normalNumberFormatter.format(Number(votosLista) || 0)} votos</Votos>
    <WrapperPartidos>
      {partidos.map((partido) => (
        <ContentPartido key={partido.sigla}>
          <PorcentajePartido>
            {percentFormatter.format(Number(partido.ratio) || 0)}
          </PorcentajePartido>
          <SiglaPartido>{partido.sigla}</SiglaPartido>
        </ContentPartido>
      ))}
    </WrapperPartidos>
  </>
)

const WrapperNameNumber = styled.div<{ color: string }>`
  display: flex;
  gap: ${spaces.xs};
  color: ${({ color }) => color};
  @media (max-width: ${spaces.tabletBreakpoint}) {
    flex-direction: column;
  }
`

const Porcentaje = styled.div`
  font-size: 20px;
  font-weight: 700;
`

const Name = styled.div`
  font-weight: 700;
  font-size: 12px;
  min-width: 75px;
  ${showInDesktop}
`

const ShortName = styled.div`
  font-weight: 700;
  font-size: 12px;
  min-width: 75px;
  ${showInMobile}
`

const Line = styled.div`
  width: 100%;
  background-color: ${colors.colorGrey26};
  height: 1px;
`

const Votos = styled.div`
  font-weight: 500;
  font-size: 12px;
  color: ${colors.colorGrey27};
`

const WrapperPartidos = styled.div``

const ContentPartido = styled.div`
  display: flex;
  gap: 10px;
`

const PorcentajePartido = styled.div`
  color: ${colors.colorGrey14};
  font-weight: 700;
  font-size: 12px;
`

const SiglaPartido = styled.div`
  font-weight: 500;
  font-size: 12px;
`

export default Pacto
